import type { CustomContentProps } from "notistack";
import { SnackbarContent } from "notistack";
import type { FunctionComponentWithRef } from "react";

import { Container } from "./styles";

export type Props = CustomContentProps & SimpleSnackbarItemProps;
export type SimpleSnackbarItemProps = {
  leftElement: JSX.Element;
  rightElement: JSX.Element;
};

export const SimpleSnackbarItem: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  leftElement,
  ref: forwardReference,
  rightElement,
  style,
}) => (
  <SnackbarContent ref={forwardReference} role="alert" style={style}>
    <Container>
      {leftElement} {rightElement}
    </Container>
  </SnackbarContent>
);

SimpleSnackbarItem.displayName = "SimpleSnackbarItem";
